/* eslint-disable */
// @ts-nocheck
export function initHeroSampleInit() {
  var panelsEl = document.getElementById('hero-sample-root')
  if (!panelsEl) return

  function bindTreeToggle(scope) {
    scope.querySelectorAll('.mi-row--toggle').forEach(function (row) {
      if (row.dataset.boundToggle) return
      row.dataset.boundToggle = '1'
      row.addEventListener('click', function () {
        var group = row.closest('.mi-bom__group')
        if (!group) return
        group.setAttribute(
          'data-open',
          group.getAttribute('data-open') === 'true' ? 'false' : 'true',
        )
      })
    })
  }

  function syncScrollbars(scope) {
    scope.querySelectorAll('.mi-bom--table').forEach(function (t) {
      var rows = t.querySelector('.mi-bom__rows')
      if (!rows) return
      function sync() {
        var sb = rows.offsetWidth - rows.clientWidth
        t.style.setProperty('--mi-sb', (sb > 0 ? sb : 0) + 'px')
      }
      sync()
      window.addEventListener('resize', sync)
      if (window.ResizeObserver) new ResizeObserver(sync).observe(rows)
    })
  }

  function revealLoading(scope) {
    var reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    scope
      .querySelectorAll('.mi-bom--table.mi-bom--loading')
      .forEach(function (t) {
        setTimeout(
          function () {
            t.classList.remove('mi-bom--loading')
          },
          reduce ? 200 : 1100,
        )
      })
  }

  function showSample(key) {
    if (!key) return
    panelsEl.querySelectorAll('.mi-tabpanel').forEach(function (p) {
      p.hidden = p.getAttribute('data-panel') !== key
    })
    panelsEl.setAttribute('data-active-sample', key)
    var active = panelsEl.querySelector(
      '.mi-tabpanel[data-panel="' + key + '"]',
    )
    if (!active || key === 'idle') return
    bindTreeToggle(active)
    syncScrollbars(active)
    revealLoading(active)
    if (window.applyRowFormats) window.applyRowFormats()
  }

  window.heroShowSample = showSample

  bindTreeToggle(panelsEl)
  syncScrollbars(panelsEl)
  panelsEl.querySelectorAll('.mi-tabpanel[data-panel]').forEach(function (p) {
    p.hidden =
      p.getAttribute('data-panel') !==
      (panelsEl.getAttribute('data-active-sample') || 'idle')
  })
}
